// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { QuickTableRow } from './QuickTableRow';
import { SEPARATOR } from '@shared/utils/Enums/Constants';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { InstrumentLookupComparer } from '@shared/utils/Instruments/InstrumentLookupComparer';
import { InstrumentTypes } from '@shared/utils/Instruments/InstrumentTypes';
export class InstrumentLookupAutoCompleteQuickTableRow extends QuickTableRow {
    constructor(ins, id, table, mayContainTrees) {
        super(null, table);
        this.childIDs = []; // <- for caching, get prop: ChildIDs
        this.collapsed = true;
        this.id = id || null;
        this.ins = ins || null;
        this.parentID = this.ParentID; // <- for caching, get prop: ParentID
        this.mayContainTrees = mayContainTrees || false;
        this.visible = true;
    }
    get Instrument() {
        return this.ins;
    }
    get Childs() {
        return this.ChildIDs.map((e) => {
            return this.table.getItemById(e);
        });
    }
    get ChildIDs() {
        return this.childIDs;
    }
    get ChildNum() {
        return this.childIDs.length;
    }
    get HasAnyChild() {
        return !(this.ChildNum === 0);
    }
    get IsPartOfTree() {
        return !!(this.HasAnyChild || this.ParentID);
    }
    get Level() {
        const p = this.Parent;
        return p ? p.Level + (p.visible ? 0 : -1) + 1 : 0; // #113220
    }
    get Parent() {
        const qt = this.table;
        const pID = this.ParentID;
        let result = null;
        if (qt && pID) {
            result = qt.getItemById(pID);
        }
        return result;
    }
    get ParentID() {
        if (isNullOrUndefined(this.parentID)) {
            this.parentID = InstrumentLookupAutoCompleteQuickTableRow.GetInsParentID(this.Instrument);
        }
        return this.parentID;
    }
    get Collapsed() {
        return this.collapsed;
    }
    set Collapsed(val) {
        this.collapsed = val;
        if (!val) // open node
         {
            this.Childs.forEach((e) => {
                e.visible = true;
            });
        }
        else {
            const f = (e, zeroGeneration = true) => {
                if (!zeroGeneration) {
                    e.visible = false;
                    e.collapsed = true;
                }
                e.Childs.forEach((ee) => {
                    f(ee, false);
                });
            };
            f(this);
        }
    }
    get tag() {
        // for DoCollapse event (~strikes request [420])
        const c = this.getFirstChild();
        return c ? c.ins : null;
    }
    getFirstChild() {
        const ch = this.Childs;
        if (ch === null || ch === void 0 ? void 0 : ch.length) {
            return ch[0];
        }
    }
    ChangeTreeCollapseState(firstGeneration = false, newVisible = null) {
        if (this.DoCollapse) {
            this.DoCollapse();
            this.Collapsed = !this.Collapsed;
        }
        const visible = firstGeneration || newVisible !== null ? newVisible : !(this.Collapsed = !this.Collapsed);
    }
    addChildNodesByInstrumentsArray(id, optionsList, currentNameFilter) {
        let filteredOptionsList = optionsList.filter((option) => {
            if (!isValidString(currentNameFilter)) {
                return true;
            }
            const displayName = option.DisplayName().toLowerCase() || '';
            const descriptionValue = option.DescriptionValue().toLowerCase() || '';
            return (!isNullOrUndefined(option) &&
                (displayName.includes(currentNameFilter) || descriptionValue.includes(currentNameFilter)));
        });
        filteredOptionsList = InstrumentLookupComparer.sortInstrumentList(filteredOptionsList, {
            pattern: currentNameFilter || '',
            isSortByInstrumentType: true
        });
        const lookup = this.terceraInstrumentLookup;
        const qtR = lookup.autoCompliteQuickTable;
        const qt = lookup.getQuickTable();
        this.SkipRequest = true;
        this.childIDs = [];
        for (let i = filteredOptionsList.length - 1; i >= 0; i-- // reverse order cuz of 113023
        ) {
            const curIt = filteredOptionsList[i];
            lookup.AddToParent(id, curIt, qt);
        }
        this.collapsed = !this.collapsed;
        qtR.set({ width: 400 });
        lookup.correctQTPopupLocation();
        lookup.updateQuickTableHeight();
    }
    AddChild(ch) {
        if (!ch.cells[0].InstrumentNameText) {
            return;
        }
        const id = ch ? ch.id : null;
        const add = !this.childIDs.includes(id) && this != ch;
        if (add) {
            this.childIDs.push(id);
            ch.parentID = this.id;
        }
        this.cells[0].setInstrumentTypeDisplay(InstrumentTypes.OPTIONS);
        return add;
    }
    getFlag() {
        let flag = this.cells.length > 0 ? this.cells[0].FlagImg : null;
        const kids = this.Childs;
        if (!flag) {
            flag = kids.length > 0 ? kids[0].getFlag() : null;
        }
        return flag;
    }
    getExchange() {
        const cells = this.cells ? this.cells[0] : null;
        const res = cells.InstrumentTradingExchangeText; // #113027 // this.HasAnyChild ? this.Childs[0].getExchange() : this.InstrumentTradingExchangeText
        return res;
    }
    getDescription() {
        return this.cells[0].InstrumentDescriptionText;
    }
    static GetInsParentID(instrument) {
        if ((instrument === null || instrument === void 0 ? void 0 : instrument.ForwardBaseInstrument) && instrument.ExpDate) {
            const baseID = instrument.ForwardBaseInstrument.GetInteriorID();
            const expDateStr = DateTimeUtils.formatDate(instrument.ExpDate, 'DD.MM.YYYY');
            return baseID + SEPARATOR + expDateStr;
        }
        return null;
    }
}
